export enum ExamAgencyMode {
  EDIT = 'Edit',
  VIEW = 'View',
  ADD = 'Add',
}

export enum AddEditAgencyType {
  UPDATE = 'UPDATE',
  CREATE = 'CREATE',
}
